import { useEffect, useState } from 'react';
import { ringCircumference } from '@/lib/ringGeometry';

// Keep globals.css `@keyframes ring-draw` (62.83) in sync if RADIUS changes.
const RADIUS = 10;
const CIRC = ringCircumference(RADIUS).toFixed(2);

type Listener = (taskId: string) => void;
let listeners: Listener[] = [];

export function fireCompleteRing(taskId: string): void {
  for (const l of listeners) l(taskId);
}

export function onCompleteRing(listener: Listener): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}

interface ActiveRing {
  taskId: string;
  rect: DOMRect;
}

export function CompleteRing() {
  const [active, setActive] = useState<ActiveRing | null>(null);

  useEffect(() => {
    return onCompleteRing((taskId) => {
      const el = document.querySelector(`[data-task-block][data-task-id="${taskId}"]`);
      if (!el) return;
      const rect = el.getBoundingClientRect();
      setActive({ taskId, rect });
      window.setTimeout(() => setActive(null), 700);
    });
  }, []);

  if (!active) return null;

  return (
    <div
      data-testid="complete-ring-overlay"
      aria-hidden
      className="pointer-events-none fixed z-celebrate"
      style={{
        top: active.rect.top,
        left: active.rect.left,
        width: active.rect.width,
        height: active.rect.height,
      }}
    >
      <svg viewBox="0 0 24 24" className="absolute right-2 top-1/2 h-6 w-6 -translate-y-1/2">
        <circle
          cx="12"
          cy="12"
          r={RADIUS}
          fill="none"
          stroke="var(--ok)"
          strokeWidth="2"
          strokeDasharray={CIRC}
          strokeDashoffset={CIRC}
          transform="rotate(-90 12 12)"
          className="complete-ring-stroke"
        />
        <path
          d="M7 12 l3 3 l7 -7"
          fill="none"
          stroke="var(--ok)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="complete-ring-check"
          opacity="0"
        />
      </svg>
    </div>
  );
}
